import { connect } from "react-redux";
import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { compose } from "redux";
import ValidationMessage from "../view/ValidationMessage";
import { signIn } from "./loginAction";
import { get } from "lodash";
import ErrorAlert from "../view/ErrorAlert";
import constant from "../../constants/constant";
import PasswordField from "../view/PasswordField";
import UtilService from "../utils/utils";
import ResetAction from '../../commonAction/ResetAction';
import {googleLogin,facebookLogin} from '../player/playerAction';
// import { GoogleLogin } from "react-google-login";
// import FacebookLogin from "react-facebook-login";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        userId: "",
        password: "",
        rememberPassword: ""
      },
      submitted: false,
      error: {}
    };
    this.handleChangeEvent = this.handleChangeEvent.bind(this);
    this.loginEvent = this.loginEvent.bind(this);
  }

  componentDidMount() {

    if (UtilService.getInfoFromStorage('localStorage', constant.IS_PASSWORD_REMEMBER)) {
      const isRememberPassword = UtilService.getInfoFromStorage('localStorage', constant.IS_PASSWORD_REMEMBER)
      if (isRememberPassword === true) {
        let userEmail = UtilService.getInfoFromStorage('localStorage', constant.USER_ID);
        this.setState({
          user: {
            userId: userEmail,
            password: UtilService.decryptText(UtilService.getInfoFromStorage('localStorage', constant.PASSWORD)), //localStorage.getItem(constant.PASSWORD),
            rememberPassword: true
          }
        });
      }
    } 
  }

  handleChangeEvent = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const { user } = this.state;
    let error = {}
    this.setState({
      user: {
        ...user,
        [name]: value
      },
      error: error
    });
    error["email"] = ""
  };

  loginEvent = event => {
    event.preventDefault();
    var rememberPassword = false;
    const { user } = this.state;
    let error = {}
    this.setState({
      submitted: true,
      error: error
    });
    let emailRegex = constant.emailRegex;
    let emailIdFromate = emailRegex.test(user.userId);
    if (emailIdFromate) {
      if (user.password) {
        //login api will be called
        if (user.rememberPassword) rememberPassword = user.rememberPassword;
        let history = this.props.history
        this.props.dispatch(signIn(user.userId, user.password, rememberPassword, history));
      }
    } else {
      error["email"] = "Please enter valid email address.";
    }
  };

  resetFiled = () => {
    this.setState({
      user: {
        userId: "",
        password: "",
        rememberPassword: ""
      },
      submitted: false,
      error: {}
    })
    this.props.ui.has_error = false;
  }

  responseGoogle = (response) => {
    const obj = {
      idTokenString:response.tokenId
    }
    if(response.tokenId) {
      this.props.dispatch(googleLogin( obj))//googleLogin
    }
   
  };
  responseFacebook = (response) => {
    console.log(response);
    const obj = {
      accessToken:response.accessToken
    }
    if(response.accessToken) {
      this.props.dispatch(facebookLogin( obj))//googleLogin
    }

  };



  render() {
    const { user, submitted, error } = this.state;
    let errorMessage = get(
      this.props,
      "login.loggin_error.data.message",
      null
    );

    let isLoggedIn = get(this.props, "login.isLoggedIn", false);
    const has_error = get(this.props, "ui.has_error", false);
    if (has_error && errorMessage == null) {
      errorMessage = get(
        this.props,
        "login.loggin_error.message",
        null
      );
    }
    const isLoading = get(this.props, "ui.is_loding", false);
    const getLocalUser = UtilService.getInfoFromStorage('localStorage', constant.CURRENT_USER) //localStorage.getItem("currentUser");
  
    if (getLocalUser) {
      isLoggedIn = true;
    }

    if (errorMessage === null) {
      errorMessage = 'Something went wrong, Please try again.'
    }

    if (isLoggedIn) {
      if(getLocalUser?.firstLogin === true){
        return <Redirect to="/termsConditions"/>
      }
      return <Redirect to="/" />;
    }

   

    return (
      <div className="login-wrapper display-table">
        <div className="display-table-cell">
          <div className="login-page position-relative">

            <button type="button" className="close popup-close-btn" data-dismiss="modal" aria-label="Close" onClick={this.resetFiled}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                  <path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666"/>
              </svg>
            </button>
            <svg className="logo mb-3" width="211.971" height="92.64" viewBox="0 0 211.971 92.64">
                <defs>
                    <radialGradient id="prefix__radial-gradient" cx=".5" cy=".5" r=".728" gradientTransform="matrix(.566 .824 -.794 .545 .615 -.185)" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#1d7439"/>
                        <stop offset="1" stopColor="#2d3c25"/>
                    </radialGradient>
                    <radialGradient id="prefix__radial-gradient-2" cx=".5" cy=".5" r=".44" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#f24e4e"/>
                        <stop offset="1" stopColor="#b52830"/>
                    </radialGradient>
                    <radialGradient id="prefix__radial-gradient-4" cx=".69" cy=".389" r=".534" gradientTransform="matrix(.937 0 0 .936 .043 .025)" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#ffa3a3"/>
                        <stop offset=".322" stopColor="#f25151"/>
                        <stop offset="1" stopColor="#e60000"/>
                    </radialGradient>
                    <radialGradient id="prefix__radial-gradient-5" cx=".69" cy=".37" r=".503" gradientTransform="matrix(.995 0 0 .936 .003 .024)" href="#prefix__radial-gradient-4"/>
                    <linearGradient id="prefix__linear-gradient" x1=".068" x2=".97" y1=".106" y2=".938" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#124e25"/>
                        <stop offset="1" stopColor="#e60000"/>
                    </linearGradient>
                    <filter id="prefix__Path_5390" width="105.227" height="71.289" x="0" y="0" filterUnits="userSpaceOnUse">
                        <feOffset/>
                        <feGaussianBlur result="blur" stdDeviation="6"/>
                        <feFlood floodColor="#fff" floodOpacity=".584"/>
                        <feComposite in2="blur" operator="in"/>
                        <feComposite in="SourceGraphic"/>
                    </filter>
                </defs>
                <g id="prefix__logo" transform="translate(771.971 -8593)">
                    <g id="prefix__Layer_x0020_1" transform="translate(-693.693 8597.231)">
                        <g id="prefix___1995880576128">
                            <path id="prefix__Path_5387" fill="#b52830" fillRule="evenodd" d="M1477.15 323.542a5.733 5.733 0 0 0 4.739-2.288l2.505 2.56a9.465 9.465 0 0 1-13.725.817 8.5 8.5 0 0 1-2.669-6.481 8.913 8.913 0 0 1 2.669-6.536 9.584 9.584 0 0 1 13.834.708l-2.451 2.723a5.675 5.675 0 0 0-4.63-2.288 5.461 5.461 0 0 0-3.758 1.416 4.978 4.978 0 0 0-1.58 3.922 5.517 5.517 0 0 0 1.471 3.976 4.89 4.89 0 0 0 3.595 1.471zm104.793-14.161c3.1 0 5.555.763 7.189 2.342a8.166 8.166 0 0 1 2.56 6.373 8.665 8.665 0 0 1-2.451 6.536c-1.634 1.579-4.139 2.4-7.516 2.4h-6.046v-17.651zm.163 14.161a5.668 5.668 0 0 0 4.139-1.362 6.11 6.11 0 0 0 0-7.952 6.039 6.039 0 0 0-4.412-1.416h-2.179v10.73zm-29.3-1.089a3.411 3.411 0 0 0 5.283 0 5.47 5.47 0 0 0 .926-3.322v-9.749h3.976v9.858a7.783 7.783 0 0 1-2.124 5.882 8.13 8.13 0 0 1-10.839 0 7.608 7.608 0 0 1-2.179-5.882v-9.858h3.976v9.749a5.138 5.138 0 0 0 .975 3.322zm-20.643-4.357a5.98 5.98 0 0 0-1.525-4.03 4.879 4.879 0 0 0-3.7-1.634 4.992 4.992 0 0 0-3.758 1.634 5.932 5.932 0 0 0-1.471 4.03 5.836 5.836 0 0 0 1.471 4.031 4.993 4.993 0 0 0 3.758 1.634 4.879 4.879 0 0 0 3.7-1.634 5.88 5.88 0 0 0 1.523-4.027zm1.307 6.482a9.08 9.08 0 0 1-6.59 2.614 8.955 8.955 0 0 1-6.536-2.614 9.205 9.205 0 0 1 0-12.963 8.955 8.955 0 0 1 6.536-2.614 9.08 9.08 0 0 1 6.59 2.614 9.2 9.2 0 0 1 0 12.963zm-37.309 2.451v-17.648h3.922v14.107h7.516v3.54z" data-name="Path 5387" transform="translate(-1468 -309)"/>
                        </g>
                    </g>
                    <g id="prefix__Layer_x0020_1-2" data-name="Layer_x0020_1" transform="translate(-648.649 8619.671)">
                        <g id="prefix___1995880576128-2" data-name="_1995880576128">
                            <path id="prefix__Path_5387-2" fill="#124e25" fillRule="evenodd" d="M2489.741 770.357c-1.416-.272-2.778-.49-4.085-.762v10.24c-2.56-.6-5.065-1.2-7.571-1.8v-36.817c4.085 0 8.115 0 12.2.054a10.622 10.622 0 0 1 6.264 1.852 12.385 12.385 0 0 1 4.085 5.556 22.27 22.27 0 0 1 1.47 8.442 21.151 21.151 0 0 1-1.362 7.9 9.569 9.569 0 0 1-3.867 4.684c.926 2.342 1.961 4.739 2.887 7.135s1.906 4.848 2.887 7.353c-2.723-.708-5.392-1.416-8.061-2.07-.817-2.015-1.634-4.031-2.451-5.991s-1.637-3.869-2.396-5.776zm4.739-14a7.538 7.538 0 0 0-1.2-4.521 4.378 4.378 0 0 0-3.486-1.743c-1.362-.109-2.778-.163-4.139-.272v11.329c1.362.163 2.778.381 4.139.545a3.6 3.6 0 0 0 3.486-1.089 6.283 6.283 0 0 0 1.199-4.246zm-20.534 12.854v7.9c-7.135-1.579-14.27-3.05-21.351-4.412v-31.59c6.917 0 13.889.054 20.861.054v7.843c-4.521-.218-8.987-.49-13.4-.708v5.61l11.765.98v7.516c-3.922-.545-7.843-1.035-11.765-1.525v5.991c4.576.764 9.26 1.581 13.89 2.344zm-39.706-9.859c-.926 1.035-1.852 2.015-2.778 3v7.135c-2.505-.327-4.957-.6-7.462-.817V741h7.462v11.874c1.688-1.906 3.431-3.813 5.12-5.773 1.743-1.961 3.432-4.031 5.174-6.046h8.279c-1.8 2.288-3.649 4.521-5.447 6.7s-3.649 4.248-5.447 6.318q2.86 4.33 5.719 8.823c1.906 3.05 3.812 6.209 5.719 9.423-2.887-.49-5.828-.98-8.715-1.416-1.307-2.015-2.56-3.976-3.812-5.882s-2.505-3.814-3.812-5.666z" data-name="Path 5387" transform="translate(-2424 -741)"/>
                        </g>
                    </g>
                    <g id="prefix__Layer_x0020_1-3" data-name="Layer_x0020_1" transform="translate(-692.222 8650.117)">
                        <g id="prefix___1995880576128-3" data-name="_1995880576128">
                            <path id="prefix__Path_5387-3" d="M1633.684 1411l1.089 3.377h3.54l-2.887 2.07 1.089 3.377-2.832-2.07-2.887 2.07 1.089-3.377-2.887-2.07h3.54z" fillRule = 'evenodd' fill="url(#prefix__radial-gradient)" data-name="Path 5387" transform="translate(-1629 -1404.377)"/>
                            <path id="prefix__Path_5393" fill="url(#prefix__radial-gradient-2)" fillRule="evenodd" d="M1908.116 1287l1.961 5.937h6.209l-5.066 3.649 1.961 5.937-5.065-3.7-5.011 3.7 1.906-5.937-5.011-3.649h6.209z" data-name="Path 5393" transform="translate(-1884.968 -1287)"/>
                            <path id="prefix__Path_5394" d="M2324.629 1411l1.09 3.377h3.595l-2.887 2.07 1.089 3.377-2.887-2.07-2.886 2.07 1.144-3.377-2.887-2.07h3.541z" fillRule = 'evenodd' fill="url(#prefix__radial-gradient)" data-name="Path 5394" transform="translate(-2282.364 -1404.377)"/>
                        </g>
                    </g>
                    <g id="prefix__Layer_x0020_1-4" data-name="Layer_x0020_1" transform="translate(-770 8619.671)">
                        <g id="prefix___1995880576128-4" data-name="_1995880576128">
                            <path id="prefix__Path_5387-4" fill="#2d3c25" fillRule="evenodd" d="M247.743 731.6v30.773c-2.07.381-4.085.708-6.155 1.089-1.961-2.451-3.976-5.011-5.882-7.625-1.961-2.669-3.922-5.447-5.882-8.224v18.137c-2.451.545-4.9 1.035-7.353 1.579v-35.621h6.209c1.906 3 3.867 5.937 5.828 8.769 1.906 2.832 3.922 5.556 5.882 8.224v-17.047c2.451 0 4.902-.054 7.353-.054zm-40.523 39.868a17.443 17.443 0 0 1-6.264.218 10.672 10.672 0 0 1-4.956-2.233c.817-3.05 1.688-6.046 2.505-8.987a11.18 11.18 0 0 0 4.139 2.179 10.29 10.29 0 0 0 4.63.218c2.887-.49 4.3-1.8 4.3-3.867a2.319 2.319 0 0 0-1.2-2.233 17.717 17.717 0 0 0-3.976-1.089 23.823 23.823 0 0 1-5.065-1.416 7.67 7.67 0 0 1-3.431-3.214 12.686 12.686 0 0 1-1.416-6.645 17.513 17.513 0 0 1 1.307-6.863 10.157 10.157 0 0 1 3.976-4.793 11.192 11.192 0 0 1 6.486-1.743 16.839 16.839 0 0 1 5.174.817 14.1 14.1 0 0 1 4.466 2.4c-.763 2.56-1.58 5.174-2.342 7.789a11.981 11.981 0 0 0-7.353-2.506 4.983 4.983 0 0 0-3.268 1.144 3.756 3.756 0 0 0-1.035 2.615 2.389 2.389 0 0 0 1.253 2.288 13.044 13.044 0 0 0 3.867 1.307 30.493 30.493 0 0 1 5.065 1.471 8.312 8.312 0 0 1 3.431 2.941 9.793 9.793 0 0 1 1.471 5.828 14.868 14.868 0 0 1-1.307 6.155 14.345 14.345 0 0 1-3.976 5.12 15.627 15.627 0 0 1-6.481 3.099z" data-name="Path 5387" transform="translate(-196 -731)"/>
                        </g>
                    </g>
                    <path id="prefix__Path_5391" fill="url(#prefix__radial-gradient-4)" d="M1819.76 758.669a16.486 16.486 0 0 1-7.571-1.743 12.631 12.631 0 0 1-5.283-4.847 10.558 10.558 0 0 1-1.416-3.323 14.859 14.859 0 0 1 0-7.571 11.73 11.73 0 0 1 1.416-3.432 13.246 13.246 0 0 1 5.283-4.956 16.842 16.842 0 0 1 15.141 0 13.757 13.757 0 0 1 6.754 8.551 17.134 17.134 0 0 1 0 7.68 12.116 12.116 0 0 1-1.471 3.323 12.864 12.864 0 0 1-5.283 4.793 16.249 16.249 0 0 1-7.57 1.525z" data-name="Path 5391" transform="translate(-2487.364 7888.671)"/>
                    <path id="prefix__Path_5392" fill="url(#prefix__radial-gradient-5)" d="M1233.76 760.248a13.926 13.926 0 0 1-7.571-.98 11.517 11.517 0 0 1-5.283-4.793 13.038 13.038 0 0 1-1.416-3.595 17.361 17.361 0 0 1-.49-4.194 18.28 18.28 0 0 1 .49-4.3 16.5 16.5 0 0 1 1.416-3.867 14.414 14.414 0 0 1 5.283-5.556 14.8 14.8 0 0 1 7.571-1.963 15.14 15.14 0 0 1 7.571 1.852 13.378 13.378 0 0 1 5.283 5.011 12.462 12.462 0 0 1 1.47 3.377 17.019 17.019 0 0 1 .436 3.813 17.4 17.4 0 0 1-.436 3.813 13.6 13.6 0 0 1-1.47 3.432 14.746 14.746 0 0 1-5.283 5.392 16.925 16.925 0 0 1-7.571 2.558z" data-name="Path 5392" transform="translate(-1933.281 7888.671)"/>
                    <g filter="url(#prefix__Path_5390)" transform="translate(-781.97 8573)">
                        <path id="prefix__Path_5390-2" fill="url(#prefix__linear-gradient)" fillRule="evenodd" d="M314.054 211.422c.436-1.253 2.124-2.233 3.922-2.723-.218-.218-.436-.272-.654-.49a.813.813 0 0 0-.381-.163l-3.1-1.961c-.49-.218-.871-.545-1.362-.763a3.473 3.473 0 0 1-.381-.109l-1.144-.49c-.654-.272-1.035-.109-1.688.381a8.3 8.3 0 0 0-1.2 1.2c-.436.708-.817 4.085-.871 4.956a39.035 39.035 0 0 0 .49 7.571 10.526 10.526 0 0 1-.054 1.852c-.109 1.035 0 .817.654 1.416-.218-.054 0 0-.163-.054-.49-.109-.49 0-.436.436a1.823 1.823 0 0 1-.327 1.035 13.914 13.914 0 0 0-.272 1.471c-.109 1.144-.871 2.451.054 2.778.109.708.163.817.817.817a2.066 2.066 0 0 0 1.144 1.2 2.591 2.591 0 0 1 .763.272 1.582 1.582 0 0 0 .763.163l-.545-.654c.218.272 1.58 1.525 2.288.763-.109-.763-1.253-1.307-.926-2.07.163-.436.98-.763 1.253-1.58.327.218.218.817 1.634.654a5.35 5.35 0 0 1-.272-.871c0-.327.109-.381-.054-.763a12.475 12.475 0 0 0-.763-1.471c-.708-1.253-1.362-.926-2.56-.218l.163-.218a2.463 2.463 0 0 1 1.362-.654c-1.688-4.466.545-8.388.381-9.423a1.015 1.015 0 0 0-.49-.654c-.49-.381-1.035-1.035-1.743-1.035 0-.054 0-.054.054-.109.272-.218.6-.054.817.054.763.49 1.416 1.2 2.124 1.743a1.68 1.68 0 0 0 .054-.545 5.637 5.637 0 0 1 .218-.545c0 .926-.272 2.179.545 2.832a2.64 2.64 0 0 1 .98.926 12.9 12.9 0 0 0 1.852 2.015 32.626 32.626 0 0 0 2.941 2.614 10.128 10.128 0 0 1-.163-2.56 4.079 4.079 0 0 1 .6-2.124 11.416 11.416 0 0 0-.327 2.778c.109 2.941 1.035 2.832 2.887 4.575.6.6 1.307 1.2 1.906 1.743 1.253 1.035 2.56 2.505 4.194 2.941.98.272 5.065.98 5.174 1.035-.654 0-2.233-.218-3-.272l-8.932-.871c-1.961-.163-3.976-.436-5.991-.545-.98-.054-1.961-.163-3-.272-.926-.109-.654-.109-1.253.49-.218.218-.381.218-.381.545a2.148 2.148 0 0 0 .272.763c.871.109 5.447.436 6.427.49l19.336 1.471c4.3.327 8.551.654 12.908.98.708.054 5.828.381 6.373.49.6.163 1.089.763 1.58 1.035a35.067 35.067 0 0 0 3.486 1.961 3.045 3.045 0 0 1-.054-1.2l.218.817.055-.109c.054-.054.054-.054.054-.109a4.454 4.454 0 0 0 .654-1.089.747.747 0 0 0-.327-.708c-.218-.109-3.431-.545-3.813-.6l3.649.272c-.327-.763.218-.98.49-.926-.817.381-.272.871.054 1.525.49.926-.49 1.362-.708 2.07a2.076 2.076 0 0 0-.054.817 1.082 1.082 0 0 0 1.035 1.089 2.25 2.25 0 0 0 .381-.6 7.252 7.252 0 0 1-.817 1.743c-.6 1.2.163 1.362.817 1.144.871-.381 1.035-1.307 1.416-1.961a8.586 8.586 0 0 0 .6-1.253 1.533 1.533 0 0 1-1.144-.545l.163.109a1.876 1.876 0 0 0 1.089.218 4.174 4.174 0 0 0 .218-1.471 1.827 1.827 0 0 1 0-.545 2.338 2.338 0 0 1 .218.763.9.9 0 0 1 .654 0c.054.49-.272 1.743-.163 2.56.109 1.307.6 1.8 1.688.98a3.6 3.6 0 0 1 0-2.505c.055-.327.055-.545.109-.871.6-.272.98.163 1.362.49.436.436.926.381 1.253.763.49.6.49.708 1.307.708.6-.054 1.416-.272 1.144-.926-.654-.327-.926.109-1.58-.654a6.892 6.892 0 0 1 .98.327 5.668 5.668 0 0 0 1.743-.054c.6 0 1.362 0 1.144-.871h-.381a5.884 5.884 0 0 1-2.179-.327c-.381-.054-.817-.109-1.253-.163a3.333 3.333 0 0 0-1.144-.327 1.563 1.563 0 0 0 .327.6 2.79 2.79 0 0 1-.654-.708c-.272-.272-.381-.436-.762-.49-.272-.054-.817-.163-1.035 0-.163.163-.218.545-.327.763l-.055.054c-.054-.327.055-.545-.109-.871a2.062 2.062 0 0 0-1.416-.054c-.272.327-.109.6-.218.98-.218-.654.163-1.2-.817-1.2l-.218.327c-.49-.654-.98.817-1.089 1.089-.163.49-.6 1.035-.708 1.471l.49-1.471a2.369 2.369 0 0 1 .218-.381c.708-1.089.163-1.144-.381-1.906h.054l.054.054c.054 0 .054 0 .054.054l.272.218a.858.858 0 0 0 .381.381c.272.054 2.832.163 3.214.218.926.054 3.7.327 4.412.272-.109-.381-.163-.545.054-.763a1.089 1.089 0 0 0 .109.708c.654.545 1.307-.708.545-1.089-.545-.218-4.793-.109-5.719-.381h.817c-.436-.6-.98.054-1.634-.163-.381-.163-.109-.327-.708-.218a2.258 2.258 0 0 0-.871.163l-25.272-2.07c1.362-.163 3.976.272 5.556-.762a6.212 6.212 0 0 0 1.253-1.089 10.234 10.234 0 0 1-2.614-.163 3.221 3.221 0 0 1-2.07-1.089 3.88 3.88 0 0 0 2.015.708 11.744 11.744 0 0 0 2.4 0 4.395 4.395 0 0 1 .054-1.471 2.536 2.536 0 0 1 .327-1.089c.054-.163 0-.054.109-.163-.109.49-.6 1.961-.163 2.56a5.286 5.286 0 0 0 2.179.926c-.163-.6-.545-.98-.218-1.8a3.745 3.745 0 0 0 .163 1.307c.218.49.49.545.871.763l.926.49a8.806 8.806 0 0 1 .98.545 9.082 9.082 0 0 1 .871.654 4.978 4.978 0 0 0 3.214.926c2.07.109 7.952.708 9.641.545-.817-1.2-3.431-4.248-4.684-4.956a2.459 2.459 0 0 0-2.179-.49 1.883 1.883 0 0 1-1.144-.218 32.583 32.583 0 0 1-2.56-2.07 3.4 3.4 0 0 0-1.8-1.144 3.969 3.969 0 0 0-2.451.763c.654-.436.871-.817 1.852-.926a2.235 2.235 0 0 1 1.634.381 2.146 2.146 0 0 0-1.362-.926c-2.342-.763-3.595 1.688-4.412 2.4l.054-.109a7.041 7.041 0 0 1 1.852-1.961c1.307-.98 1.58-.654 2.887-.381a5.134 5.134 0 0 0-.545-.545l-.49-.654a19.8 19.8 0 0 0-3.214-2.941c-.327.49-.218.436-.926.708-2.669.98-3.214.871-4.848 3.322-.381.545-.6 1.362-.871 1.8.054-.109.054-.272.109-.436l.926-1.906.926-1.253c.654-.763.926-.763 2.015-1.2.871-.381 1.8-.436 2.233-1.089-.163-.49-.436-.436-.654-.654a4.969 4.969 0 0 0-.708-.436 5.442 5.442 0 0 1-.763-.436c-.218-.109-.545-.218-.817-.327-.871-.327-2.614-.98-3.322.381a4.418 4.418 0 0 0-.327 1.8c0 .654.055 1.253 0 1.906a7.49 7.49 0 0 1-1.089 3.322l.054-.272a8.044 8.044 0 0 0 .6-3.758c-.381.272-.545.654-1.089.763a6.547 6.547 0 0 0 1.035-1.144c.436-.654.272-.926.163-1.634-.054-.763-.054-3.268-.109-3.595-.109.218-.109.381-.218.6l-.49 1.089a2.555 2.555 0 0 1-.327.49 3.927 3.927 0 0 1-2.179 1.471 4.238 4.238 0 0 0 2.56-2.669 6.843 6.843 0 0 0 .163-3.813 5.524 5.524 0 0 0-3.813-3.976c-3.431-1.2-7.462.545-8.715 3.05a6.958 6.958 0 0 0-.763 3.54 6.47 6.47 0 0 0 .708 3.214c.163.163.49.6.545.654-.163-.054-.436-.272-.763-.163-.817.272-.6 1.743-.436 2.4a3.526 3.526 0 0 0 .871 1.743c.49.381.871-.218 1.688.054a9.118 9.118 0 0 0 1.035 2.832 2.139 2.139 0 0 0 .817.98c.926.708 2.342 2.342 2.56 2.505a4.5 4.5 0 0 0 2.288.708 3.213 3.213 0 0 1-2.505-.708 8.105 8.105 0 0 0-1.743-1.307c-.163-.109-.163-.054-.272-.163-.327-.218-.708-.436-1.035-.654a6.689 6.689 0 0 1-2.179-1.253c-.327-.272-.545-.708-.817-.98a9.735 9.735 0 0 1 .109 2.124 10.816 10.816 0 0 0-1.089-1.144c-.381-.327-.763-.763-1.307-.763-.163-.871-.109-3.867.381-4.466 0 .545-.654 2.614-.163 4.194.272.109.218 0 .545.272s1.144 1.089 1.416 1.253a13.789 13.789 0 0 0-.163-2.07c.817.708 1.362 1.8 2.4 2.124a6.762 6.762 0 0 1 1.634.871 9.006 9.006 0 0 1-1.58-2.233 12.571 12.571 0 0 0-.545-1.525c-.327-.545-.763-.054-1.253-.272a3.31 3.31 0 0 1-1.362-2.4 3.357 3.357 0 0 1-.054-1.471c.109-.763.218-.545.6-1.035a11.725 11.725 0 0 1-.708-3.268c-.054-.817.272-2.56 0-2.832-.6-.436-2.451.817-2.887 1.2a7.427 7.427 0 0 0-1.688 2.124c.218-.381.381-.817.654-1.253a6.048 6.048 0 0 1 1.852-1.688.755.755 0 0 0-.6-.654c-.49-.163-.6.163-.871.327-.272-.054-.545-.218-.871.054a8.078 8.078 0 0 0-1.579 2.015c.163-.327.381-.708.6-1.144.163-.272.6-.871.49-1.253-.327-.327-.327-.109-.654-.109-.218-.054-.327-.272-.654-.218-1.362.054-2.07 2.778-2.015 3.214a2.922 2.922 0 0 1 .272-1.852c.218-.436.817-1.2.926-1.525a5.525 5.525 0 0 0-1.416-.871.956.956 0 0 0-.871-.109 5.622 5.622 0 0 0-3.868 2.449z" data-name="Path 5390" transform="translate(-288.68 -186.59)"/>
                    </g>
                </g>
            </svg>

            <ErrorAlert errorMessage={`${errorMessage}`} isShow={has_error} />
            <form className="login-form" onSubmit={this.loginEvent} noValidate>
              <div className="form-group position-relative">
                <label>Email address</label>
                <div className="position-relative">
                  <input
                    type="email"
                    placeholder="Enter email address"
                    aria-describedby="emailHelp"
                    name="userId"
                    value={user.userId}
                    onChange={this.handleChangeEvent}
                    className={`form-control ${
                      submitted && !user.userId ? "input-error" : submitted && user.userId && error["email"] ? "input-error" : ""
                      }`}
                  />
                  {submitted && !user.userId && (
                    <ValidationMessage message="Please enter email address" />
                  )}
                  {submitted && user.userId && error["email"] && (
                    <ValidationMessage message="Please enter valid email address" />
                  )}
                </div>
              </div>

              <div className="form-group position-relative">
                <label>Password</label>
                <div className="position-relative">
                  <PasswordField
                    name="password"
                    value={user.password}
                    placeholder="Enter password"
                    handleChangeEvent={this.handleChangeEvent}
                    submitted={submitted}
                    errorClass={!user.password}
                  />
                  {submitted && !user.password && (
                    <ValidationMessage message="Please enter password" />
                  )}
                </div>
              </div>
              <div className="form-group m-0 mb-4 d-flex justify-content-between">
                <div>
                  <label
                    className="form-check-label position-relative d-flex align-items-center"
                    htmlFor="exampleCheck1"
                  >
                    <input
                      type="checkbox"
                      className="form-check-input checkbox-element"
                      name="rememberPassword"
                      checked={user.rememberPassword}
                      onChange={this.handleChangeEvent}
                      id="exampleCheck1"
                    />
                    <span className="checkmark mr-2"></span>
                    Remember Me
                  </label>
                </div>
                <span className="forgot-password cursor-pointer" onClick={this.props.hideLayout}>
                  Forgot your password?
                </span>
              </div>
              <div className="position-relative">
                <div className={isLoading ? "loader" : null}></div>
                <input
                  type="submit"
                  className={`btn login-btn w-100 ${
                    isLoading ? "pointer-event disabled " : null
                    }`}
                  value="Sign In"
                />
              </div>
            </form>
            {/* <div className="col-lg-12 col-md-12 d-flex justify-content-center view_or">
              OR
            
            </div> */}
            {/* <div className="col-lg-12 col-md-12 pr-lg-2 d-flex justify-content-center">
          <GoogleLogin
              clientId={
                "519027832515-d3ihamfd5a1772kjjtsgvat3fg0mo4hu.apps.googleusercontent.com"
              }
              render={(renderProps) => (
                <button
                  className="w3-panel w3-card google_btn "
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                >
                  <i class="fa fa-google"></i>Login in with Google
                </button>
              )}
              buttonText="Login"
              onSuccess={this.responseGoogle}
              onFailure={this.responseGoogle}
              cookiePolicy={"single_host_origin"}
            />
            </div>
            <div className="col-lg-12 col-md-12">
            <FacebookLogin
              appId="577452803562028"
              // autoLoad={true}
              fields="name,email,picture"
              callback={this.responseFacebook}
              cssClass="my-facebook-button-class w3-panel w3-card google_btn ml-9"
              icon="fa-facebook"
            />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    this.props.dispatch(ResetAction());
  }
}
const mapStateToProps = state => {
  return {
    login: state.loginReducer,
    ui: state.ui
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Login);

